import { useEffect, useState } from "react";
import { ArrowRight, Pickaxe, Spade } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { MemberLayout } from "../../components/Layouts";
import { api, readUser } from "../../lib/api";


export default function GamesHub() {
  const [user, setUser] = useState(readUser());
  const [catalog, setCatalog] = useState({ games: [] });
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/auth/me").then((response) => setUser(response.data)).catch(() => navigate("/login"));
    api.get("/games").then((response) => setCatalog(response.data)).catch(() => {});
  }, [navigate]);
  const poker = catalog.games.find((game) => game.id === "poker");
  return (
    <MemberLayout user={user} active="GAMES">
      <section className="games-intro" data-testid="games-hub-heading">
        <div><span className="eyebrow">PLAY DESK</span><h2>Choose your game.</h2></div>
        <div className="games-balance"><span>AVAILABLE BALANCE</span><strong data-testid="games-hub-balance">${Number(catalog.balance || user?.balance || 0).toFixed(3)}</strong></div>
      </section>
      <div className="games-hub-grid">
        <article className="game-tile game-tile-poker" data-testid="games-hub-poker-card">
          <img src="/game/five-card-draw-table.jpeg" alt="Top-down 5 Card Draw table with three computer opponents" />
          <div className="game-tile-overlay"><span className="game-status"><i /> LIVE TABLE</span><Spade size={34} /><h3>5 Card Draw</h3><p>Face three computer opponents, replace your discards, and take the 0.40 USDT pot.</p><div className="game-tile-foot"><b data-testid="poker-stake-amount">0.10 USDT entry</b><Link data-testid="games-open-poker" to="/dashboard/games/poker" className="btn btn-accent" aria-disabled={poker?.status === "paused"}>{poker?.status === "paused" ? "Paused" : "Join table"} <ArrowRight size={16} /></Link></div></div>
        </article>
        <article className="game-tile game-tile-mining" data-testid="games-hub-mining-card">
          <img src="/game/mining-scene.jpeg" alt="Miner working beside mine wagons" />
          <div className="game-tile-overlay"><span className="game-status"><i /> DAILY SHIFT</span><Pickaxe size={34} /><h3>Daily Mine</h3><p>Load two wagons, collect every strike, then return after cooldown.</p><div className="game-tile-foot"><b>100 strikes / cycle</b><Link data-testid="games-open-mining" to="/dashboard#mining-game" className="btn btn-ghost">Open mine <ArrowRight size={16} /></Link></div></div>
        </article>
      </div>
    </MemberLayout>
  );
}